import DB_CONST from '../../config/db_const';

export const SET_ROLE = 'user/SET_ROLE';

const initialState = {
  role: DB_CONST.USER_ROLES.GUEST,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_ROLE:
      return {
        ...state,
        ...action.user,
      };
    default:
      return state;
  }
};
